import { useRequestEvent } from '#imports'

import type { ExperimentName } from '../config'
import { getRequestExperiments } from '../server/getRequestExperiments'
import { getDefaultExperiments } from '../utils'

declare global {
  interface Window {
    __EXPERIMENTS__?: Record<ExperimentName, string>
  }
}

/**
 * Retrieve experiments.
 *
 * @example
 * const experiments = useExperiments()
 */
export function useExperiments(): Record<ExperimentName, string> {
  const defaultExperiments = getDefaultExperiments()

  if (import.meta.server) {
    const event = useRequestEvent()

    if (event) return getRequestExperiments(event)

    return { ...defaultExperiments }
  }

  return {
    ...defaultExperiments,
    // By using underscore dangles, we follow the same structure as Nuxt.
    // eslint-disable-next-line no-underscore-dangle
    ...window.__EXPERIMENTS__,
  }
}
